import { routes } from 'defs';
import appConfig from 'helper/mapBackendConfig';

const win: any = window;

/*
 * Returns the Login / Logout return URLs
 */

function getFrontendLoginReturnToURL(redirectPath: string | null): string {
	let frontendLoginReturnToURL: string = '';

	if (redirectPath) {
		frontendLoginReturnToURL = `${win.location.origin}${appConfig.env.baseName}${redirectPath}`;
	} else {
		frontendLoginReturnToURL = `${win.location.origin}${appConfig.env.baseName}${routes.dashboard.indexRoute.href}`;
	}

	return frontendLoginReturnToURL;
}

export const getMigrosLoginReturnToURL = (redirectPath: string | null): string => {
	return encodeURI(getFrontendLoginReturnToURL(redirectPath));
};

export const getMigrosLogoutReturnToURL = (): string => {
	/*
	 * Logout return to url has changed from 'appConfig.env.migrosImpulsCoachLandingPage.href'
	 * to the current value, please referr to the ticket for more information
	 * @see https://jira.migros.net/browse/PULSWM-2658
	 */

	const frontendReturnToURL = `${appConfig.env.coachBaseUrl}${routes.login.indexRoute.href}`;

	return encodeURI(frontendReturnToURL);
};
